import { render } from "./AlertsSubMenu.vue?vue&type=template&id=0f2960d6"
import script from "./AlertsSubMenu.vue?vue&type=script&lang=js"
export * from "./AlertsSubMenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__